import React, { Component } from "react";
import PropTypes from "prop-types";
import Toolbar from "react-md/lib/Toolbars";
import Button from "react-md/lib/Buttons";

class AdminToolbar extends Component {
  constructor(props) {
    super(props);

    this.handleCustomerMenuClick = this.handleCustomerMenuClick.bind(this);
    this.handleStaffMenuClick = this.handleStaffMenuClick.bind(this);
  }

  handleCustomerMenuClick() {
    this.props.history.push("/customer");
  }

  handleStaffMenuClick() {
    this.props.history.push("/staff");
  }

  render() {
    const { onLogout, rangeLocation, locations } = this.props;
    const locationName =
      rangeLocation in locations ? locations[rangeLocation].name : "";
    const switchPageButton =
      this.props.location.pathname === "/staff" ? (
        <Button flat onClick={this.handleCustomerMenuClick}>
          Customer
        </Button>
      ) : (
        <Button flat onClick={this.handleStaffMenuClick}>
          Staff
        </Button>
      );
    const title =
      this.props.location.pathname === "/staff"
        ? `${locationName} - STAFF`
        : `${locationName} - CUSTOMER`;

    return (
      <Toolbar
        colored
        style={{
          backgroundColor: "black",
        }}
        title={locationName ? title : ""}
        fixed
        actions={[
          switchPageButton,
          <Button key="logout" icon onClick={onLogout}>
            power_settings_new
          </Button>,
        ]}
      />
    );
  }
}

AdminToolbar.propTypes = {
  onLogout: PropTypes.func.isRequired,
  rangeLocation: PropTypes.string.isRequired,
  /* eslint-disable react/forbid-prop-types */
  // Firebase data structure
  locations: PropTypes.object.isRequired,
  // React-router's history
  history: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
  // React-router's location
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default AdminToolbar;



// WEBPACK FOOTER //
// ./src/admin/components/Toolbar/Toolbar.jsx